import { render } from "./AvatarIcon.vue?vue&type=template&id=2b732112&bindings={}"
import script from "./AvatarIcon.vue?vue&type=script&lang=ts"
export * from "./AvatarIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script